import { Link } from "react-router-dom";
import { LogOut, RefreshCw, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const DashboardHeader = ({ loading, onRefresh }) => {
    const { user, logout } = useAuth();
    return (
        <header className="border-b border-ivory/10">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-5 sm:px-12 lg:px-20">
                <div className="flex items-center gap-4">
                    <img src="/brand/mark.png" alt="Noir Nest" className="h-10 w-auto" />
                    <div>
                        <p className="font-serif text-xl">Leads Dashboard</p>
                        <p data-testid="admin-user-email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40">{user?.email}</p>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <Link to="/" data-testid="admin-view-site" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ivory/60 hover:text-gold">
                        View site <ArrowUpRight size={13} />
                    </Link>
                    <button data-testid="admin-refresh-btn" onClick={onRefresh} aria-label="Refresh" className="flex h-9 w-9 items-center justify-center rounded-full border border-ivory/15 text-ivory/60 hover:border-gold hover:text-gold">
                        <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
                    </button>
                    <button data-testid="admin-logout-btn" onClick={logout} className="inline-flex items-center gap-2 rounded-full border border-ivory/20 px-4 py-2 text-xs uppercase tracking-[0.2em] text-ivory/70 hover:border-terra hover:text-terra">
                        <LogOut size={13} /> Sign out
                    </button>
                </div>
            </div>
        </header>
    );
};

export const PillGroup = ({ options, value, onChange, testPrefix }) => (
    <div className="flex gap-2">
        {options.map((o) => (
            <button
                key={o.id}
                data-testid={`${testPrefix}-${o.id}`}
                onClick={() => onChange(o.id)}
                className={`rounded-full border px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                    value === o.id ? "border-gold bg-gold text-night" : "border-ivory/20 text-ivory/60 hover:border-ivory/50 hover:text-ivory"
                }`}
            >
                {o.label}
            </button>
        ))}
    </div>
);
